import axios from 'axios'
import { Commit } from 'vuex'

const url_api4 = process.env.VUE_APP_API_URL_4

export default {
    namespaced: true,
    state: {
        translator: null
    },
    getters: {
        getTranslator: (state: { translator: AnalyserOptions }) => state.translator,
    },
    mutations: {
        SET_TRANSLATOR(state: { translator: any }, payload: any) {
            state.translator = payload
        },
    },
    actions: {
        async translator({ commit }: { commit: Commit }, payload: { text: any }) {
            try {
                const data = JSON.stringify({
                    text: payload.text
                })

                const config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: url_api4,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                    },
                    data: data
                }

                const response = await axios.request(config)

                const translated = response.data
                commit('SET_TRANSLATOR', translated)
                return translated

            } catch (error) {
                console.error("Terjadi kesalahan saat menerjemahkan:", error)
                throw error
            }
        }


    },
}
